import {
  dbReducerNorm,
  findById,
  insert as insertOne,
  removeOne,
} from '@weblite/persist'
import { RootState } from '$setup/redux'

const COLLECTION = 'keyval'

export function createKeyvalStorage<T>(key: string) {
  const remove = removeOne(COLLECTION)
  const insert = insertOne(COLLECTION)
  return {
    async del() {
      await remove(key)
    },
    get() {
      // TODO #verify what happens if not in redux?
      return findById(COLLECTION, key)?.value as T
    },
    async set(fields: Partial<T>) {
      await insert({ id: key, value: { ...this.get(), ...fields } })
    },
  }
}

export function createKeyvalView<T>(key: string) {
  return (state: RootState): T => state.main.keyval[key]?.value
}

export const keyvalReducer = dbReducerNorm(['main', COLLECTION])
